export default __webpack_public_path__ + "static/media/male.3d38b040.png";